import { useNavigate } from 'react-router-dom'

export default function PaymentCancelPage() {
	const navigate = useNavigate()

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50">
			<div className="bg-white p-8 rounded shadow text-center">
				<h1 className="text-2xl font-bold mb-2 text-orange-600">Payment Cancelled</h1>
				<p className="text-gray-700 mb-4">
					Your payment was cancelled. No charges were made to your account.
				</p>
				<div className="space-x-4">
					<button 
						onClick={() => navigate('/dashboard/client')}
						className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
					>
						Back to Dashboard
					</button>
					<button 
						onClick={() => navigate(-1)}
						className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
					>
						Try Again
					</button>
				</div>
			</div>
		</div>
	)
}

